var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M241.5,176.4c2.8-10.4,10.2-20.4,13.5-30.8c3.2-9.9,0.8-20.6,10.6-31.9c12.9-14.8,48-19.9,74.4-22.4 c-7.1,0.1-14.2,0.2-21.1,0.5c-18.4,0.9-36.5,2-51.8,11c-17.8,10.4-19.5,20.4-23.8,37c-4,15.5-12.5,33.1-11.9,49 c0.6,15.8,7.6,40,13.1,46.2c0.5,0.5,0.9,1,1.3,1.5C247.4,215.6,236,196.9,241.5,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M463.7,129.2c-3.2-16-6.1-26.6-25.3-33c-17.9-6-40.6-5.8-59.3-5.2c-12.6,0.3-26,0.2-39.1,0.3 c-26.4,2.5-61.5,7.6-74.4,22.4c-9.8,11.3-7.4,22-10.6,31.9c-3.3,10.4-10.7,20.4-13.5,30.8c-5.5,20.6,5.9,39.3,4.3,60.1 c4.1,4.7,6.6,10.6,8.5,16.1c2.1-9.4-4.7-23.1,1.5-44.1c2.1-7,8.6-14.1,13.7-19.9c6.4-7.3,6.2-10.6,6.9-19.9 c1.3-19.9,16.2-20.7,35.5-18.1c18.6,2.5,35.7,6.4,55.7,4.2c18.3-2,36.1-9.5,52.7-7.6c23.3,2.6,18.2,21.5,23.5,37.5 c4.4,13.2,14,17.3,17,39.9c1.8,13.7,3.3,24.9,2.7,41.4c19.1-38.1,10.1-60.1,12.8-93.6C477.5,156.2,467.3,147.1,463.7,129.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle3D);
export default __webpack_public_path__ + "static/media/man_hairstyle_3d.440e35871582884deb02db9a3154edb8.svg";
export { ForwardRef as ReactComponent };